import React, { Component, Fragment } from "react";

import Header from "../header/Header";

import "./Policy.css";

class Policy extends Component {
  render() {
    return (
      <div className="BackgroundHomeframe">
        <Header />
        <div
          className="container agreementContainer"
          style={{ paddingBottom: "150px" }}
        >
          <div className="agreementHeader">
            <h1 className="agreementHead">eSahyogi Privacy And Data Policy</h1>
          </div>
          <div className="agreementInfo">
            <p className="info">
              We want you to understand how and why eSahyogi Platform or The
              Ideaz Factory (“eSahyogi”, “we”, or “us”) collects, uses and
              shares information about you when you use our websites, mobile
              apps, widgets, and other online products and services
              (collectively, the “Services”) or when you otherwise interact with
              us or receive a communication from us. This Privacy Policy applies
              to all of our services.
            </p>
            <p class="pointHead topMarg">Information Collection and Use</p>
            <ol className="agreementPoints">
              <li className="pointHead" style={{ marginTop: "0px" }}>
                Information you Provide to us
              </li>
              <p className="info">
                We collect information you provide to us directly when you use
                the Services. This includes:
              </p>
              <p className="info">
                <span style={{ fontWeight: 700 }}>Personal Information : </span>
                In order to access the Services, you may be required to register
                on our website or platform and provide some personal
                information, such as your name and email address or other
                contact information. If you provide with personal information,
                we will retain and may use that information to contact or
                respond to you. We also may retain or use your information for
                the period of time needed to pursue legitimate business
                interests. Legitimate business interest may include customizing
                the services we provide to you and to ensure compliance with
                applicable laws, ensuring you are satisfied with eSahyogi’s
                support and services, authentication confirmation for secure
                handling of eSahiyogi’s clients accounts, etc. Our Services
                collect, store and process this personal information on servers
                in the Republic of India.
              </p>
              <p className="info topMarg">
                <span style={{ fontWeight: 700 }}>Action taken : </span>We
                collect information about the actions you take when using the
                Services. This includes your interaction with our platform
                service. If you purchase products or services from us, we
                collect certain information from you, including your name,
                address, email address, and information about the product and
                service you are purchasing. Payments are processed by
                third-party payment processors, so please refer to applicable
                processor’s terms and privacy policy for more information about
                how payment information is processed and stored.
              </p>
              <li className="pointHead">
                Information we collect automatically
              </li>
              <p className="info">
                When you access or use our Services, we may also automatically
                collect information about you. This includes:
                <br />
                <span style={{ fontWeight: 700 }}>Log data : </span>
                We may log information when you access and use the Services.
                This may include your IP address, user-agent string, browser
                type, operating system, device information, pages visited, links
                clicked, the requested URL, hardware settings, etc. Except for
                the IP address used to create your account, eSahyogi will delete
                any IP addresses collected after 100 days
                <br />
                <br />
                <span style={{ fontWeight: 700 }}>
                  Cookies and similar technologies :{" "}
                </span>
                We may receive information from cookies, which are pieces of
                data your browser stores and sends back to us when making
                requests, and similar technologies. We use this information to
                improve your experience, understand user activity, personalize
                content and advertisements and improve the quality of our
                Services. For example, we store and retrieve information about
                your preferred settings. For more information on how you can
                disable cookies please see “Control Over Privacy” below.
                <br />
                <br />
                <span style={{ fontWeight: 700 }}>Location : </span>We may
                receive and process information about your location. For
                example, with your consent, we may collect information about the
                specific location of your mobile device. We may also receive
                location information from you when you choose to share such
                information on our Services, including by associating your
                actions with location, or we may derive your approximate
                location from other information about you, including your IP
                address.
              </p>
              <li className="pointHead">
                Information we collect from other sources
              </li>
              <p className="info">
                We may receive information about you from other sources,
                including publicly available databases or social media websites,
                and combine this data with information we already have about
                you. This helps us to update, expand and analyse our records,
                identify new customers, and provide products and services that
                may be of interest to you.
                <br />
                <br />
                Examples of the types of personal information that may be
                obtained from public sources or purchased from third parties and
                combined with information we already have about you (for the
                purpose of creating more tailored advertising and products), may
                include:
              </p>
              <ol class="infoList">
                <li className="info">
                  Purchased marketing data about our customers from third
                  parties
                </li>
                <li className="info">
                  Data and other information available publicly on social media
                  sites.
                </li>
              </ol>
              <li className="pointHead">How we use information about you</li>
              <p className="info">
                We use information about you to:
                <br />
                <ol class="infoList">
                  <li className="info">
                    Provide, maintain and improve the Services
                  </li>
                  <li className="info">Reseach and develop new services</li>
                  <li className="info">
                    Help protect the safety of eSahyogi and our users, which
                    includes blocking suspicious usage, and enforcing the
                    eSahyogi user agreement and our other policies;
                  </li>
                  <li className="info">
                    Send you technical notices, updates, security alerts,
                    invoices and other support and administrative messages or
                    emails
                  </li>
                  <li className="info">Provide customer service</li>
                  <li className="info">
                    Communicate with you about products, services, offers,
                    promotions, and provide other news and information we think
                    will be of interest to you (for information about how to opt
                    out of these communications, see “Control Over Privacy”
                    below);
                  </li>
                  <li className="info">
                    Monitor and analyze trends, usage, and activities in
                    connection with our Services; and
                  </li>
                  <li className="info">
                    Personalize the Services and provide advertisements, and
                    features that match user profiles or interests.
                  </li>
                </ol>
              </p>
              <li className="pointHead">Prohibited Activities</li>
              <p className="info">
                When accessing or using the Services, you must respect others
                and their rights including these Terms, so that we all may
                continue to use and enjoy the Services. We support the
                responsible reporting of security vulnerabilities. When
                accessing or using our Services, you shall not:
              </p>
            </ol>
            <p className="pointHead">Disclosure of Personal Information</p>
            <p className="info">
              Except for the limited situations given below, we do not share,
              sell, or give away your personal information to third parties:
            </p>
            <p className="info topMarg">
              <span style={{ fontWeight: 700 }}>Linked Services : </span>If you
              link eSahyogi account with a third-party service, eSahyogi will
              share information you authorize with that third-party service. You
              can control this sharing as described in “Control Over Privacy”
              below.
            </p>
            <p className="info topMarg">
              <span style={{ fontWeight: 700 }}>Partners : </span>We may share
              information with vendors, consultants, and other service providers
              (but not with advertisers and ad partners) who need access to such
              information to carry our work for us. The partner’s use of
              personal data will be subject to appropriate confidentiality and
              security measures.
            </p>
            <p className="info topMarg">
              <span style={{ fontWeight: 700 }}>Legal Compliance : </span>We may
              share information in response to a request for information if we
              believe disclosure is in accordance with, or required by, any
              applicable law, regulation, legal process or governmental request,
              including, but not limited to, meeting national security or law
              enforcement requirements. To the extent the law allows it, we will
              attempt to provide you with prior notice before disclosing your
              information in response to such a request.
            </p>
            <p className="info topMarg">
              <span style={{ fontWeight: 700 }}>Acquisitions : </span> As
              eSahyogi develops, we may buy other businesses or their assets or
              sell our business assets. Customer information is generally one of
              the business assets involved in such a transaction. Thus, in the
              event that eSahyogi or all of its assets are acquired, or in cases
              of liquidation, dissolution, reorganization or other transfer of
              the business, customer information, including any visitor
              information collected through our Services, may be on eof the
              transferred assets.
            </p>
            <p className="info topMarg">
              <span style={{ fontWeight: 700 }}>Consent : </span> We may share
              information about you with your consent or at your discretion.{" "}
              <br />
              De-identified information: We may share information about you that
              has been aggregated or anonymized such that it cannot reasonably
              be used to identify you. For example, we may show the total number
              of times an action was conducted on our platform, without
              identifying who the users were.
            </p>
            <p className="info topMarg">
              <span style={{ fontWeight: 700 }}>Affiliates : </span>We may share
              information between and among The Ideaz Factory and any of our
              affiliates, subsidiaries and other companies under common control
              and ownership.
            </p>
            <p className="pointHead">Ads and Analytics Partners</p>
            <p className="info">
              We may partner with third-party advertisers, ad networks, and
              analytics providers to deliver advertising and content targeted to
              your interests and to better understand your use of the Services.
              These third parties may collect information sent by your computer,
              browser, or mobile device in response to a request for content,
              such as unique identifiers, your IP address, or other information
              about your computer or device
            </p>
            <ol className="agreementPoints">
              <li className="pointHead">Advertisers and Ad Network</li>
              <p className="info">
                Our ad partners and ad networks may use cookies and related
                technologies to collect information when ads are delivered to
                you on our Services, but eSahyogi does not link to or provide
                them with your actual eSahyogi account details. This means that
                eSahyogi does not share your individual account habits with
                advertisers. eSahyogi cannot see advertisers’ cookies and
                advertisers will not see eSahyogi cookies.
              </p>
              <li className="pointHead">Analytics Partners</li>
              <p className="info">
                We use analytics partners (such as Google Analytics) to help
                analyze usage and traffic for our Services. As an example, we
                may use analytics partners to analyze and measure, in the
                aggregate, the number of unique visitors to our Services.
              </p>
            </ol>
            <p className="pointHead">Data Security and Storage</p>
            <p className="info">
              Protecting the security of your personal information is very
              important to us. When you transmit personal information from your
              device to our servers, your information is protected by both a
              “firewall” (a combination of computer hardware and software that
              helps keep unauthorized visitors from accessing information within
              our computer network) and industry standard SSL (secure socket
              layer) encryption. Once we receive your transmission, we will take
              reasonable precautions to ensure its security on our systems.
              While we utilize all of our security and data protection
              preventative measures, the internet is inherently insecure. As a
              result, while eSahyogi strives to protect your personal
              information and privacy, we cannot guarantee or warrant the
              security of any information you disclose or transmit to us online.
              <br />
              <br />
              Users are required to sign-in to specific secured areas of
              eSahyogi Services using a user ID and password. These authenticate
              the user and are designed to safeguard against unauthorized access
              and use of a user's account. The user ID and password are used on
              a secure web page and encrypted when transmitted over the
              internet.
              <br />
              <br />
              The safety and security of your information also depends on you.
              If you have access to password-protected features, never share
              your password with anyone else, notify us promptly if you believe
              your password security has been breached, and remember to log off
              of this site before you leave your computer. Similarly, any
              personally identifiable information or personally sensitive data
              that you disclose through online forums, may be collected and used
              by others. We recommend caution when giving out personal
              information to others in these public online forums. If at any
              point you suspect or become aware of a security incident (i.e.
              your password is stolen or you receive suspicious communication
              from someone holding themselves out to be a eSahyogi employee or
              from a fake website claiming to be affiliated with eSahyogi),
              please forward the communication to us or report the incident by
              in writing to eSahyogi at accounts@theideazfactory.com . The
              personal information of our users or clients is stored on our
              servers located in the Republic of India. We do not transfer any
              such data outside of the servers in Republic of India or to any
              third party, without your authorization.
            </p>
            <p className="pointHead">Control an Privacy</p>
            <ol className="agreementPoints">
              <li className="pointHead">
                Access and changing your information
              </li>
              <p className="info">
                When using our Services, we make a good faith effort to provide
                you with access to your personal information and either correct
                this data if it is inaccurate or delete inaccurate data at your
                request if it is not otherwise required to be retained by law or
                for legitimate business purposes. Upon your request, eSahyogi
                will provide you with information about whether we hold, or
                process on behalf of a third party, any of your personal
                information. To request this information please contact us at
                accounts@theideazfactory.com . You may access, correct, or
                request deletion of your personal information by contacting us
                at accounts@theideazfactory.com . In certain circumstances we
                may be required by law to retain your personal information, or
                may need to retain your personal information in order to
                continue providing a service. We will respond to these requests
                within a reasonable timeframe. Users must identify themselves
                and the information requested to be accessed, corrected or
                removed prior to processing such requests, and we may decline to
                process such requests that are deemed unreasonable or
                inappropriate. In any case, the information access and data
                corrections are performed free of charge, except if doing so
                would require a disproportionate effort. Due to the methods that
                we maintain certain services, once your information is corrected
                or deleted; residual copies may take a period of time before
                they are deleted from our active systems and may remain in our
                backup systems.
              </p>
              <li className="pointHead">Deleting your account</li>
              <p className="info">
                You may delete your account information at any time from
                software. When you delete your account, any information linked
                to that account will be deleted by us within a reasonable
                timeframe unless otherwise required by applicable law.
              </p>
              <li className="pointHead">Cookies</li>
              <p className="info">
                Most web browsers are set to accept cookies by default. If you
                prefer, you can usually choose to set your browser to remove or
                reject first- and third-party cookies. Please note that if you
                choose to remove or reject cookies, this could affect the
                availability and functionality of our Services.
              </p>
              <li className="pointHead">Do not track</li>
              <p className="info">
                Most modern web browsers give you the option to send a Do Not
                Track signal to the websites you visit, indicating that you do
                not wish to be tracked. However, there is no accepted standard
                for how a website should respond to this signal, and we do not
                take any action in response to this signal. Instead, in addition
                to publicly available third-party tools, we offer you the
                choices described in this policy to manage the collection and
                use of information about you.
              </p>
              <li className="pointHead">Promotionl Communication</li>
              <p className="info">
                You may opt out of receiving some or all categories of
                promotional communications from us by following the instructions
                in those communications or by contacting us at. If you opt out
                of promotional communications, we may still send you
                non-promotional communications, such as information about your
                account or your use of the Services.
              </p>
              <li className="pointHead">Location</li>
              <p className="info">
                If you initially consent to our collection of location
                information, you can subsequently stop the collection of this
                information at any time by changing the preferences on your
                mobile device.
              </p>
            </ol>
            <p className="pointHead topMarg">Data Retention</p>
            <p className="info">
              We store the information we collect for as long as it is necessary
              for the purpose(s) for which we originally collected it. We may
              retain certain information for legitimate business purposes or as
              required by law.
            </p>
            <p className="pointHead topMarg">Privacy for Children</p>
            <p className="info">
              Persons under the age of 18 are not allowed to create an account
              or otherwise use the Services. Additionally, we do not knowingly
              collect information from those below the age of 18 on our
              platforms. If you are under the age of 18, please do not provide
              any personal information to us. If we become aware that we have
              collected personal information from a child under the age of 18,
              we will make commercially reasonable efforts to delete such
              information from our database.
            </p>
            <p className="pointHead topMarg">Changes of Terms</p>
            <p className="info">
              We may change this Privacy Policy from time to time. If we do, we
              will let you know by revising the date at the top of the policy.
              We will notify you of any material changes to this Privacy Policy
              by posting a notice, on the homepage of the website for a
              reasonable period of time prior to the changes becoming effective,
              that this Privacy Policy has been updated. We encourage you to
              review the Privacy Policy whenever you access or use our Services
              or otherwise interact with us to stay informed about our
              information practices and the ways you can help protect your
              privacy. By continuing to use our Services after Privacy Policy
              changes go into effect, you agree to be bound by the revised
              policy.
            </p>
            <p className="pointHead topMarg">Contact Us</p>
            <p className="info">
              If you have any questions about this Privacy Policy, please
              contact us at <b>accounts@theideazfactory.com</b>
              <br />
              <br />
              <b>
                <p className="info">The Ideaz Factory,</p>
                <p className="info">SCO 34, Second Floor,</p>
                <p className="info">Madhya Marg, Sector 26,</p>
                <p className="info">Chandigarh.</p>
              </b>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Policy;
